/** Angular Imports */
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

/** rxjs Imports */
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

/** Custom Services */
import { ClientsService } from '../clients.service';

/**
 * Client datatable resolver.
 */
@Injectable()
export class ClientDatatableResolver {
  private clientsService = inject(ClientsService);

  /**
   * Returns the Client datatables.
   * @returns {Observable<any>}
   */
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const clientId = route.parent.parent.paramMap.get('clientId');
    const datatableName = route.paramMap.get('datatableName');
    return this.clientsService.getClientDatatable(clientId, datatableName).pipe(catchError(() => of(null)));
  }
}